module.exports = "../../../../platform/assets/pageMainIcon/simple_danjuweihulei5.svg";